import { Table } from '@tanstack/react-table';
import { ListFilter } from 'lucide-react';
import { Button } from '../../../../../design-system/button/button';
import { Popover } from '../../../../../design-system/popover/popover';
import { TableFiltersContent } from './table-filters-content';

type TableFiltersProps<TData> = {
  table: Table<TData>;
};

export const TableFilters = <TData,>({ table }: TableFiltersProps<TData>) => {
  return (
    <Popover
      triggerElement={
        <Button variant="secondary" iconLeft={<ListFilter />} className="bg-white">
          Filters
        </Button>
      }
      content={<TableFiltersContent table={table} />}
      align="end"
      className="min-w-max"
    />
  );
};
